export default __webpack_public_path__ + "static/media/newJob.2aca2305.jpg";